"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validRequied = exports.validPhone = exports.vaildEmail = void 0;
const vaildEmail = value => /^[A-Za-z\d\u4e00-\u9fa5]+[-,_.+*#·A-Za-z\d\u4e00-\u9fa5]*@([A-Za-z\d\u4e00-\u9fa5_-]+[.])+[A-Za-z\d\u4e00-\u9fa5]{1,20}$/i.test(value);
exports.vaildEmail = vaildEmail;
const validPhone = (currCountryCode, value) => {
  if (value == undefined || value == '') {
    return true;
  }
  if (currCountryCode === '86' && !/^1[0-9]{10}$/.test(value)) {
    return false;
  }
  if (currCountryCode !== '86' && !/^[0-9]{5,11}$/.test(value)) {
    return false;
  }
  return true;
};
exports.validPhone = validPhone;
const validRequied = value => {
  try {
    if (!value || (value + '').replace(/\s+/g, '') == '') {
      return false;
    }
  } catch (err) {
    return false;
  }
  return true;
};
exports.validRequied = validRequied;